<template>
    <tr
        class="holiday-request-row"
        @click="$emit('review')"
    >
        <td>{{ request.user ? request.user.name : '-' }}</td>
        <td>{{ request.start_at | date }}</td>
        <td>{{ request.end_at | date }}</td>
        <td>{{ days }}</td>
        <td>
            <status :status="request.status" />
        </td>
        <td>
            <span v-if="request.reviewer">{{ request.reviewer.name }}</span>
            <span v-else>-</span>
        </td>
        <td class="text-right">
            <router-link
                v-if="request.user_id"
                :to="{ name: 'admin.users.edit', params: { id: request.user_id } }"
                class="btn btn-sm btn-link"
                @click.native.stop
            >
                View User
            </router-link>
            <a
                v-if="request.start_at"
                :href="calendarHref"
                class="btn btn-sm btn-link"
                target="_blank"
                rel="noopener noreferrer"
                @click.stop
            >
                View in Calendar
            </a>
            <button
                class="btn btn-primary btn-sm"
                type="button"
                @click.stop="$emit('review')"
            >
                Review
            </button>
            <button
                class="btn btn-danger btn-sm"
                type="button"
                :disabled="deleting"
                @click.stop="confirmDelete"
            >
                Delete
            </button>
        </td>
    </tr>
</template>
<script>
import Status from '../../CalendarEventStatus.vue';
import {calculateDaysDiff} from '../../../include/Calendar';
import CalendarEventsService from '../../../services/CalendarEventsService';

export default {
    components: {
        Status,
    },
    props: {
        request: {
            required: true,
            type: Object,
        },
    },
    data () {
        return {
            deleting: false,
        };
    },
    computed: {
        days () {
            return calculateDaysDiff(this.request.start_at, this.request.end_at);
        },
        calendarHref () {
            const date = window.moment(this.request.start_at).format('YYYY-MM-DD');
            const eventId = this.request.id ? `&event=${this.request.id}` : '';

            return `/#/office/calendar?date=${date}${eventId}`;
        },
    },
    methods: {
        confirmDelete () {
            const confirmed = window.confirm(
                'Are you sure you want to delete this holiday request?'
            );
            if (!confirmed) {
                return;
            }
            this.deleting = true;
            CalendarEventsService.deleteEvent(this.request)
                .then(() => {
                    this.$emit('deleted', this.request);
                })
                .catch((err) => {
                    console.error(err);
                    window.alert('Error: Failed to delete holiday request');
                })
                .finally(() => {
                    this.deleting = false;
                });
        },
    },
};
</script>
<style scoped lang="scss">
.holiday-request-row {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/office/holiday-requests/RowComponent.vue